import React from 'react';
import { useIsE2E } from './useIsE2E';
import useUser from './api/useUser';
import { recordAnalyticsEvent } from '../utils/analytics/record';

type UseRecordEventReturnValue = (eventName: string, attributes?: Record<string, string>) => void;

const useRecordEvent = (): UseRecordEventReturnValue => {
    const { user } = useUser({});
    const isE2E = useIsE2E();

    const recordEventCallback = React.useCallback(
        (eventName: string, attributes?: Record<string, string>) => {
            if (isE2E) return;
            // The request is signed with the caller's credentials, so hold events until auth resolves.
            if (user === 'loading') return;
            recordAnalyticsEvent(eventName, attributes);
        },
        [user, isE2E],
    );

    return recordEventCallback;
};

export default useRecordEvent;
